

import React from 'react'

export default function Home() {
    
    return (
        <>
        <section >
        <div className="container " style={{marginTop:200, marginBottom:50}}>
            <div className="conatiner" >
                <h1 className='myName' style={{fontSize:"3.8rem"}}>  <span className="hii"> Hii</span>, there <br></br>I am Pankaj Kumar</h1>
                <h1 style={{fontSize:"3.8rem" , fontFamily:'Alkatra'}}> </h1>
                <p className='container content-justify' style={{fontSize:"1.4rem", textAlign:"left" }}>


                
                    
                </p>
            </div>

        </div>

        </section>
        </>
    )
}

